// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","photo_area":"stT6jn","AniFadeIn":"O7Y7GL","AniFadeOut":"X56BCf","AniRotate":"_7QDp5z","AniPlaceholderFadeOut":"CvkOiw"};